'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Base2 = require('./Base');

var _Base3 = _interopRequireDefault(_Base2);

var _throttle = require('./helpers/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Throttler = function (_Base) {
  _inherits(Throttler, _Base);

  function Throttler() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, Throttler);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Throttler)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this._wrapHandler = function (fn) {
      return (0, _throttle2.default)(fn, _this.time);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Throttler;
}(_Base3.default);

exports.default = Throttler;


//////////////////
// WEBPACK FOOTER
// ./~/react-throttle/lib/classes/processors/Throttler.js
// module id = 2885
// module chunks = 0